module.exports = __webpack_public_path__ + "img/listBg1.8d06ea87.png";